import React, { Component } from 'react';
import '../styles/footer.css';

class Footer extends Component {
  render() {
    return (
      <div className="footerContainer">
        <div className="socials">
          <div>
            <a
              href="https://www.facebook.com/KittyTuttleInteriors/"
              target="_blank"
              alt="Facebook"
              name="Facebook"
              aria-label="Facebook"
              rel="noopener noreferrer"
            >
              <i className="fa fa-facebook-official fa-lg" />
            </a>
          </div>
          <div>
            <a
              href="https://www.instagram.com/kittytuttleinteriors/"
              target="_blank"
              alt="Instagram"
              name="Instagram"
              aria-label="Instagram"
              rel="noopener noreferrer"
            >
              <i className="fa fa-instagram fa-lg" />
            </a>
          </div>
          <div>
            <a
              href="https://www.pinterest.com/kittytuttle/kitty-tuttle-interiors/"
              target="_blank"
              alt="Pinterest"
              name="Pinterest"
              aria-label="Pinterest"
              rel="noopener noreferrer"
            >
              <i className="fa fa-pinterest fa-lg" />
            </a>
          </div>
          <div>
            <a
              href="https://www.houzz.com/pro/velvet10/kitty-tuttle-interiors/"
              target="_blank"
              alt="Houzz"
              name="Houzz"
              aria-label="Houzz"
              rel="noopener noreferrer"
            >
              <i className="fa fa-houzz fa-lg" />
            </a>
          </div>
        </div>
        <div className="rights">
          <p>© Kitty Tuttle Interiors / All rights reserved.</p>
          <p>Photography by Chris Little Photography</p>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/containers/footer.js